import React, { type PropsWithChildren } from "react";

import { useSplitPaymentFlow } from "~/hooks/use-split-payment-flow";

import { useModal } from "../../hooks/use-modal";

import { DialogCancelPayment } from "./dialog-cancel-payment";

export const SplitPaymentGuard = ({ children }: PropsWithChildren) => {
  const { isActive: isSplitPaymentActive } = useSplitPaymentFlow();
  const { showModal, hideModal } = useModal();

  if (isSplitPaymentActive) {
    return React.cloneElement(children as React.ReactElement, {
      onClick: (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        showModal({
          component: <DialogCancelPayment onClose={hideModal} />
        });
      }
    });
  }

  return children;
};
